import { createSlice } from '@reduxjs/toolkit';

import { getPrevNextIds } from '../../helpers/common';

import { STATUS } from '../../constants/rule';

import { fetchRule, fetchRules, snoozeRules } from '../actions/rule';

const ruleSlice = createSlice({
  name: 'rule',
  initialState: {
    data: null,
    error: null,
    loading: false,
    rule: null,
    sortedData: []
  },
  reducers: {
    setSortedData: (state, action) => {
      state.sortedData = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      // Fetch Rules
      .addCase(fetchRules.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRules.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchRules.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Rule
      .addCase(fetchRule.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRule.fulfilled, (state, action) => {
        const { prev_id, next_id } = state.sortedData?.length
          ? getPrevNextIds(state.sortedData, action.payload?.id)
          : { prev_id: action.payload.prev_id, next_id: action.payload.next_id };
        state.rule = { ...action.payload, prev_id, next_id };
        state.loading = false;
      })
      .addCase(fetchRule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Snooze Rules
      .addCase(snoozeRules.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(snoozeRules.fulfilled, (state, action) => {
        const data = JSON.parse(JSON.stringify(state.data));
        state.data['rules'] = data.rules?.map(rule => ({
          ...rule,
          is_snoozed: action.payload.ids?.includes(rule.id) ? !rule.is_snoozed : rule.is_snoozed,
          snooze_status: action.payload.ids?.includes(rule.id) && rule.is_snoozed ? STATUS.ACTIVE : STATUS.SNOOZED
        }));
        state.data['active_rules_count'] = action.payload.snooze
          ? data['active_rules_count'] - action.payload.ids?.length
          : data['active_rules_count'] + action.payload.ids?.length;
        state.loading = false;
      })
      .addCase(snoozeRules.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setSortedData } = ruleSlice.actions;
export default ruleSlice.reducer;
